import {
  Component,
  EventEmitter,
  Input,
  Output,
  Renderer2,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { CdiInvoiceResolutionRequestDto } from "../../../core/models/cdi/CDIInvoiceResolutionRequestDto";
import { CDISummaryService } from "../../../core/services/cdi-resolution-summary.service";
import { LoaderService } from "../../../core/services/loader.service";
import { OrderSummaryService } from "../../../core/services/order-summary.service";
import { CommonModule } from "@angular/common";
import { SelectModule } from "primeng/select";
import { FormsModule } from "@angular/forms";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../orders/components/order-summary/order-summary.component";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@UntilDestroy()
@Component({
  selector: "jni-cdi-header",
  templateUrl: "./cdi-header.component.html",
  styleUrls: ["./cdi-header.component.scss"],
  imports: [
    CommonModule,
    SelectModule,
    FormsModule,
    ModalStackerComponent,
    OrderSummaryComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class CdiHeaderComponent {
  submitColorChange = false;
  @Input() isDisableSubmit = false;
  @Input() CDIResolutionNumber = "";
  @Input() poNumber = "";
  @Input() saleOrderId = "";
  @Input() cdiRecId = 0;

  @Input() vendorName = "";
  @Input() vendorNumber = "";
  @Input() cdi = 0;
  @Input() reason = "";
  @Input() cdiActionVal = "";
  @Input() jobNameHeader = "";
  @Input() customerName = "";
  @Input() recId = "";
  @Input() tableId = "";
  @Input() isFromIRScreen = false;
  @Input() quickQuoteValue = "";
  @Output() submitQuickNoteAPIEvent = new EventEmitter();
  @Output() quickNoteMandatoryEvent = new EventEmitter<boolean>();
  @Input() set diff(value: number) {
    if (typeof value == "number") {
      if (value != 0) {
        this.cdiAction = this.cdiActionDuplicate.filter(
          x => x.name != "NoActionNeeded"
        );
        this.submitColorChange = false;
      } else if (value === 0) {
        this.cdiAction = this.cdiActionDuplicate.filter(
          x => x.name === "NoActionNeeded"
        );
        // Change the action value to No action needed
        this.cdiActionVal = "NoActionNeeded";
        this.submitColorChange = true;
      } else {
        this.cdiAction = this.cdiActionDuplicate;
        this.submitColorChange = false;
      }
      this.diff = value;
    }
  }

  get diff() {
    return this.diff;
  }

  @Output() getCdiSummaryEvent: EventEmitter<number> =
    new EventEmitter<number>();

  showPdfViewer = "";
  orderDisplayModal = false;
  processOCRInvoice = 1;

  cdiAction = [
    // { name: "None", value: "None" },
    { name: "Pending", value: "Pending" },
    { name: "ApproveToMatch", value: "Approve to match vendor net cost" },
    { name: "AddToFreight", value: "Add to freight" },
    { name: "AddNetLine", value: "Add net line" },
    { name: "PendingCredit", value: "Pending credit / RA in route" },
    { name: "NotApproved", value: "Not approved - BC/BAC contacting vendor" },
    { name: "NoActionNeeded", value: "No action needed - BC/BAC resolved CDI" },
    // { name: "AutoClose", value: "Auto closed" },
    { name: "BCBACResolved", value: "BC/BAC Resolved" },
    {
      name: "SplitFreightNetLine5050",
      value: "Split Freight + Net Line (50/50)",
    },
  ];

  cdiActionDuplicate = [
    // { name: "None", value: "None" },
    { name: "Pending", value: "Pending" },
    { name: "ApproveToMatch", value: "Approve to match vendor net cost" },
    { name: "AddToFreight", value: "Add to freight" },
    { name: "AddNetLine", value: "Add net line" },
    { name: "PendingCredit", value: "Pending credit / RA in route" },
    { name: "NotApproved", value: "Not approved - BC/BAC contacting vendor" },
    { name: "NoActionNeeded", value: "No action needed - BC/BAC resolved CDI" },
    // { name: "AutoClose", value: "Auto closed" },
    { name: "BCBACResolved", value: "BC/BAC Resolved" },
    {
      name: "SplitFreightNetLine5050",
      value: "Split Freight + Net Line (50/50)",
    },
  ];

  constructor(
    private _toastr: JniToastrService,
    private _cdiSummaryService: CDISummaryService,
    private _loaderService: LoaderService,
    private _orderSummaryService: OrderSummaryService,
    private renderer: Renderer2
  ) {}

  // getCDISummary(PurchaseOrderNumber: string) {
  //   this._loaderService.setLoaderState(true);
  //   this._cdiSummaryService
  //     .getCDISummary(PurchaseOrderNumber)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this._loaderService.setLoaderState(false);
  //         if (res.data) {
  //           this.vendorName = res.data.vendorNameD365;
  //           this.vendorNumber = res.data.vendorAccountD365;
  //           this.cdi = res.data.id;
  //           this.reason = res.data.reasonD365;
  //         }
  //       },
  //       error: (res) => {
  //         this._loaderService.setLoaderState(false);
  //       }
  //     });

  //   // this.vendorName = "Hirsch Gift";
  //   // this.vendorNumber = "10012345";
  //   // this.cdi = "11/12/22";
  //   // this.reason = "Extra Items";
  // }

  onPreview() {
    this._loaderService.setLoaderState(true);
    this._orderSummaryService.printPOForSalesOrder(this.poNumber).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (!res.data) {
          this._toastr.error("Error", res.message);
          return;
        }
        const blob = this.b64toBlob(res.data, "application/pdf");
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  redirectToSummary(saleOrderId: string) {
    if (saleOrderId) {
      this.saleOrderId = saleOrderId;
      this.orderDisplayModal = true;
    }
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  onCdiActionSubmit() {
    if (!this.isDisableSubmit) {
      if (
        !this.quickQuoteValue &&
        (this.cdiActionVal === "PendingCredit" ||
          this.cdiActionVal === "NotApproved" ||
          this.cdiActionVal === "BCBACResolved")
      ) {
        this._toastr.error("Error", "The quick notes box cannot be empty");
        return;
      }
      this._loaderService.setLoaderState(true);
      const cdiInvoiceResolutionFormObject = {
        recId: this.recId,
        processOCRInvoice: this.processOCRInvoice,
        tableId: this.tableId?.toString() ?? "",
        cDIAction: this.cdiActionVal,
      } as CdiInvoiceResolutionRequestDto;

      this._cdiSummaryService
        .SubmitCdiInvoiceResolution(cdiInvoiceResolutionFormObject)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            this.getCdiSummaryEvent.emit(this.cdiRecId);
            if (res?.status?.toLowerCase() === "success") {
              this._toastr.success(
                "Success",
                res.message || "CDI resolution submitted successfully"
              );
              this.isDisableSubmit = true;
              this.isDisableSubmit =
                this.cdiActionVal === "Pending" ? false : true;

              if (
                this.quickQuoteValue &&
                (this.cdiActionVal === "PendingCredit" ||
                  this.cdiActionVal === "NotApproved" ||
                  this.cdiActionVal === "BCBACResolved")
              ) {
                // submit the quick note
                this.submitQuickNoteAPIEvent.emit();
              }
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error submitting cdi resolution"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error submitting cdi resolution"
            );
          },
        });
    }
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  cdiActionOnChangeEvent() {
    if (
      this.cdiActionVal === "PendingCredit" ||
      this.cdiActionVal === "NotApproved" ||
      this.cdiActionVal === "BCBACResolved"
    ) {
      this.quickNoteMandatoryEvent.emit(true);
    } else {
      this.quickNoteMandatoryEvent.emit(false);
    }
  }
}
